import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Option } from '@telespot/protocols/data-access';

@Component({
    selector: 'ts-segmentation-protocol-cell',
    templateUrl: './segmentation-protocol-cell.component.html',
    styleUrls: ['./segmentation-protocol-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SegmentationProtocolCellComponent {
  @Input() label!: Option;
  @Input() canEdit = true;
  @Input() checked = false;
  @Input() pinned = false;

  @Output() readonly selectLabel = new EventEmitter<string>();
  @Output() readonly pinLabel = new EventEmitter<string>();

  optionCySuffix(): string {
    const ext = this.label as Option & { className?: string };
    return ext.className ?? this.label.id;
  }

  onSelectClick(): void {
    this.selectLabel.emit(this.label.id);
  }

  onPinClick(event: MouseEvent): void {
    event.stopPropagation();
    this.pinLabel.emit(this.label.id);
  }
}
